export default __webpack_public_path__ + "static/angharad-mckenzie-2cf54d8114af1af171dae1e61f1f5c95.gif";